//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {windVane} from '../../../utils/tmallGenius'
import radar from '../../../items/radar.vue'

export default {
  components: {radar,},
  data() {
    return {}
  },
  beforeRouteEnter(to, from, next) {
    windVane.setNavTitle("添加ZigBee子设备");
    next();
  },
  /*------------------------------------------- 开始运行 -------------------------------------------------------*/
  created() {
    setTimeout(()=>{
      this.$router.push({
        path: '/connect/zigbee/hub_add_remote',
      })
    }, 2000);
  },
  methods: {
    /*------------------------------------------- 绑定函数 -------------------------------------------------------*/
    /*  取消点击
    * */
    cancelClick(){
      this.$router.go(-2);  //回首页
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/connect/zigbee/Scan.vue